import { lessonByNumber, restAfter, type ProgressView } from '@gc/shared';
import { LessonCard } from '../components/LessonCard.js';

export interface TodayProps {
  progress: ProgressView;
  busy: boolean;
  onToggle: (day: number, done: boolean) => void;
  onTool: (kind: string, id: string) => void;
}

/** Экран по умолчанию: ровно одно занятие — то, которое сейчас. */
export function Today({ progress, busy, onToggle, onTool }: TodayProps): JSX.Element {
  const day = progress.currentDay === null ? null : lessonByNumber(progress.currentDay);

  if (!day) {
    return (
      <div className="screen">
        <div className="card center">
          <h2>🏆 Курс пройден</h2>
          <p className="hint">
            Все {progress.total} занятий позади. Возвращайся к любому из них в разделе «План» —
            и держи привычку: 15 минут в день важнее любого расписания.
          </p>
        </div>
      </div>
    );
  }

  const rests = restAfter(day.day);

  return (
    <div className="screen">
      <div className="progressbar" aria-label="Прогресс курса">
        <div className="fill" style={{ width: `${(progress.completed / progress.total) * 100}%` }} />
        <span className="mono">
          {progress.completed} из {progress.total}
          {progress.streak > 1 ? ` · 🔥 ${progress.streak}` : ''}
        </span>
      </div>

      <LessonCard day={day} done={false} busy={busy} onToggle={onToggle} onTool={onTool} />

      {rests.length > 0 && (
        <p className="hint after">
          После этого занятия по плану пауза: {rests[0]!.text}
        </p>
      )}
    </div>
  );
}
